import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "./utils"

const paginationControlVariants = cva(
  "inline-flex cursor-pointer items-center justify-center rounded-md text-sm font-medium transition-colors outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 aria-disabled:cursor-not-allowed aria-disabled:opacity-40 disabled:cursor-not-allowed disabled:opacity-40",
  {
    variants: {
      size: {
        default: "min-h-11 min-w-11 px-3",
        compact: "min-h-6 min-w-6 px-1.5",
      },
      current: {
        true: "text-white",
        false: "",
      },
    },
    defaultVariants: {
      size: "default",
      current: false,
    },
  },
)

function Pagination({
  className,
  "aria-label": ariaLabel = "Pagination",
  ...props
}: React.ComponentProps<"nav">) {
  return (
    <nav
      aria-label={ariaLabel}
      className={cn("flex flex-wrap items-center justify-center gap-2", className)}
      {...props}
    />
  )
}

function PaginationControl({
  className,
  size,
  current,
  ...props
}: React.ComponentProps<"button"> & VariantProps<typeof paginationControlVariants>) {
  return (
    <button
      type="button"
      aria-current={current ? "page" : undefined}
      className={cn(paginationControlVariants({ size, current }), className)}
      {...props}
    />
  )
}

function PaginationEllipsis({ className, ...props }: React.ComponentProps<"span">) {
  return (
    <span
      aria-hidden="true"
      className={cn("inline-flex min-h-11 min-w-11 items-center justify-center text-sm", className)}
      {...props}
    >
      …
    </span>
  )
}

export { Pagination, PaginationControl, PaginationEllipsis, paginationControlVariants }
